/* eslint no-param-reassign: "error" */

export default {
  SET_ALL_ALTERNATIVE_CONTRACTS(state, data) {
    state.alternativeContracts = data;
  },

  SET_CURRENT_ALTERNATIVE_CONTRACT(state, data) {
    state.currentAlternativeContract = data;

    state.addedAlternativeLessorsIds = state.currentAlternativeContract.lessorIds;
  },

  EDIT_ALTERNATIVE_CONTRACT_VALUE(state, formField) {
    state.currentAlternativeContract[formField.name] = formField.value;
  },

  ADD_ALTERNATIVE_CONTRACT(state, data) {
    state.alternativeContracts.push(data);
    state.alternativeKinds = {
      isExceptionToArticle3OfIFRS16: false,
      isIrrelevant: false,
      isShortTerm: false,
      isVariableLeasePayments: false,
      isNotRentContract: false,
      isLowValue: false
    }
  },

  UPDATE_ALTERNATIVE_LESSOR(state, data) {
    state.addedAlternativeLessorsIds[data.index] = +data.value;
  },

  DELETE_ALTERNATIVE_LESSOR(state, data) {
    state.addedAlternativeLessorsIds.splice(data.index, 1);
  },

  ADD_ALTERNATIVE_LESSOR(state) {
    state.addedAlternativeLessorsIds.push('');
  },

  SET_ALTERNATIVE_KINDS(state, data) {
    for (let prop in data) {
      if (data.hasOwnProperty(prop)) {
        state.alternativeKinds[prop] = data[prop];
      }
    }
  },

  SET_ALT_CONTRACT_CHANGE_CONDITION_STATE(state, value) {
    state.isAltContractRawEditing = value;
  },
};
